<div class="flex flex-col gap-4">
  <div [formGroup]="theForm" class="grid grid-cols-3 gap-2 pt-2 items-center">
    <div class="col-start-2 font-bold mb-2">
      {{ 'project.steps.overallResults.offer' | transloco }}
    </div>
    <div class="font-bold mb-2">{{ 'project.steps.overallResults.contract' | transloco }}</div>

    <span>{{
      feeCategories.findLabel('service').title ||
        ('project.steps.rfq.invitationPreview.previewPriceList.cardTitle.service.fees' | transloco)
    }}</span>
    <app-model-field-number
      id="offer.totalServiceFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      [value]="originalOffer().totalServiceFees"
      [isReadOnly]="true"
      [minFractionDigits]="2"
      [alignRight]="true"
    ></app-model-field-number>
    <app-form-field-number
      id="totalServiceFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      fieldName="totalServiceFees"
      [showButtons]="false"
      [minFractionDigits]="2"
      [alignRight]="true"
      [isReadOnly]="isReadOnly()"
    />

    <span>{{
      feeCategories.findLabel('implementation').title ||
        ('project.steps.rfq.invitationPreview.previewPriceList.cardTitle.implementation.fees'
          | transloco)
    }}</span>
    <app-model-field-number
      id="offer.implementationFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      [value]="originalOffer().implementationFees"
      [isReadOnly]="true"
      [minFractionDigits]="2"
      [alignRight]="true"
    ></app-model-field-number>
    <app-form-field-number
      id="implementationFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      fieldName="implementationFees"
      [showButtons]="false"
      [minFractionDigits]="2"
      [alignRight]="true"
      [isReadOnly]="isReadOnly()"
    />

    <span>{{
      feeCategories.findLabel('integrationSetup').title ||
        ('project.steps.rfq.invitationPreview.previewPriceList.cardTitle.integrationSetup.fees'
          | transloco)
    }}</span>
    <app-model-field-number
      id="offer.integrationSetupFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      [value]="originalOffer().integrationSetupFees"
      [isReadOnly]="true"
      [minFractionDigits]="2"
      [alignRight]="true"
    ></app-model-field-number>
    <app-form-field-number
      id="integrationSetupFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      fieldName="integrationSetupFees"
      [showButtons]="false"
      [minFractionDigits]="2"
      [alignRight]="true"
      [isReadOnly]="isReadOnly()"
    />

    <span>{{
      feeCategories.findLabel('other').title ||
        ('project.steps.rfq.invitationPreview.previewPriceList.cardTitle.otherImplementation.fees'
          | transloco)
    }}</span>
    <app-model-field-number
      id="offer.integrationOtherFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      [value]="originalOffer().integrationOtherFees"
      [isReadOnly]="true"
      [minFractionDigits]="2"
      [alignRight]="true"
    ></app-model-field-number>
    <app-form-field-number
      id="integrationOtherFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      fieldName="integrationOtherFees"
      [showButtons]="false"
      [minFractionDigits]="2"
      [alignRight]="true"
      [isReadOnly]="isReadOnly()"
    />

    <span>{{
      'project.steps.rfq.invitationPreview.previewPriceList.cardTitle.total.fees' | transloco
    }}</span>
    <app-model-field-number
      id="offer.totalAllYearsFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      [value]="originalOffer().totalAllYearsFees"
      [isReadOnly]="true"
      [minFractionDigits]="2"
      [alignRight]="true"
    ></app-model-field-number>
    <app-form-field-number
      id="totalAllYearsFees"
      [icon]="extractCurrencyIcon(currencyCode())"
      fieldName="totalAllYearsFees"
      [showButtons]="false"
      [minFractionDigits]="2"
      [alignRight]="true"
      [isReadOnly]="true"
    />

    <p-divider class="col-start-2 col-span-2" />
    <app-form-field-number
      id="contractDurationMonths"
      fieldName="contractDurationMonths"
      label="project.steps.overallResults.contractDurationMonths"
      mode="integer"
      [step]="3"
      [isReadOnly]="isReadOnly()"
      class="col-start-2"
    />
    <app-form-field-datepicker
      id="contractSigningDate"
      fieldName="contractSigningDate"
      label="project.steps.overallResults.contractSigningDate"
      [showClear]="false"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-datepicker>

    @if (comment()) {
      <app-model-field-textarea
        id="offer.comment"
        label="common.comment"
        [value]="comment()"
        [isReadOnly]="true"
        class="col-span-3 mt-4"
      ></app-model-field-textarea>
    }
  </div>

  @if (theForm.valid && hasChanges()) {
    <div class="flex justify-end gap-2 mt-4">
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="onSubmit()"
      ></app-project-step-save-button>
    </div>
  }

  <app-decision-reason-field
    [projectId]="projectId()"
    [hrToolDirectusId]="hrToolDirectusId()"
    [initialReasonText]="offerProviderDetails().reasonText"
    [isReadOnly]="reasonReadOnly()"
    (reasonSatisfied)="reasonSatisfied.emit($event)"
  ></app-decision-reason-field>
</div>
